// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ki1l","content":"styles_content__1HO0O","tableWrap":"styles_tableWrap__2ZMMd"};